import { NavListItemWithBlockDescription, Select } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { LegalStatusDisplayItem } from '@features/invoicingSettings/types/legalStatusDisplayItem'
import { getFrenchLegalStatusOptions } from '@features/invoicingSettings/utils/getFrenchLegalStatusOptions'

import { useMissingCompanyDetailsForm } from '../../../../../../contexts/missingCompanyDetailsFormContext'

export const CompanyLegalStatus = (): ReactElement => {
  const { t } = useTranslation()
  const {
    missingCompanyDetailsForm: { FormItem, trigger },
  } = useMissingCompanyDetailsForm()

  return (
    <FormItem
      name="legalStatus"
      label={t('settings.organization.organization_info.basic_info.legal_status.label')}
      render={({ field: { value, onChange, ...props } }) => (
        <Select<LegalStatusDisplayItem>
          {...props}
          items={getFrenchLegalStatusOptions(t)}
          dropdownItemRender={(props) => <NavListItemWithBlockDescription {...props} />}
          dropdownSize="xxxl"
          size="sm"
          dropdownMaxHeight="fullScreen"
          onSelect={(id?: string) => {
            onChange(id)
            trigger('sharedCapital')
          }}
          placement="bottom-start"
          selectedId={value}
          withSearch={false}
        />
      )}
    />
  )
}
